module.exports = __webpack_public_path__ + "static/img/okamoto_02.7f79168.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/recruit/2025/top/story/okamoto_02.png
// module id = VYkR
// module chunks = 0